import * as z from "zod/v4";

export const enableContextual = {
  name: "enableContextual" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
